module.exports = __webpack_public_path__ + "static/media/mode-64.dca7c876.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-64.svg
// module id = 1017
// module chunks = 2